import { transforms } from "@react-thermal-printer/image";
import {
  Br,
  Line,
  Printer,
  Text,
  Row,
  render,
  Cashdraw,
  Image as Imag,
  Cut,
  QRCode,
} from "react-thermal-printer";
import Cookies from "js-cookie";

var device;
var endpoints = Cookies.get("endpoints");
var tipoimp = Cookies.get("tipoimp");
var tipoposd = Cookies.get("tipoposd");
let impresoraConectada = false;
let impresoraActual = null;
let tipoImpresoraActual = null;
let impresoraActualId = null;

const PRINTER_CONFIG = {
  reconnectAttempts: 5,
  reconnectDelay: 1500,
  operationTimeout: 10000,
  bluetoothChunkSize: 20,
  serialBaudRate: 9600,
  usbInterface: 0,
};

const printerState = {
  selectedPrinterId: Cookies.get("selectedPrinterId") || null,
  printers: {},
  usbDevice: null,
  serialPort: null,
  bluetoothDevice: null,
  bluetoothCharacteristic: null,
  connected: false,
  connecting: false,
  reconnecting: false,
  manualRelease: false,
  printQueue: Promise.resolve(),
  usbVendorId: Cookies.get("usbVendorId")
    ? Number(Cookies.get("usbVendorId"))
    : null,
  usbProductId: Cookies.get("usbProductId")
    ? Number(Cookies.get("usbProductId"))
    : null,
  usbSerialNumber: Cookies.get("usbSerialNumber") || null,
  serialVendorId: Cookies.get("serialVendorId")
    ? Number(Cookies.get("serialVendorId"))
    : null,
  serialProductId: Cookies.get("serialProductId")
    ? Number(Cookies.get("serialProductId"))
    : null,
  bluetoothDeviceId: Cookies.get("bluetoothDeviceId") || null,
  bluetoothDeviceName: Cookies.get("bluetoothDeviceName") || null,
  bluetoothServiceUUID:
    Cookies.get("bluetoothServiceUUID") ||
    "0000ffe0-0000-1000-8000-00805f9b34fb",
  bluetoothCharacteristicUUID:
    Cookies.get("bluetoothCharacteristicUUID") ||
    "0000ffe1-0000-1000-8000-00805f9b34fb",
};

const resizeImage = (url, maxWidth = 800, maxHeight = 800, quality = 0.9) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = maxHeight;

      const ctx = canvas.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Canvas compression to Blob failed."));
          }
        },
        "image/png",
        quality,
      );
    };
    img.onerror = (err) => reject(new Error("Failed to load image from URL."));
  });
};

const mergeImagesForPrinter = (imgUrl1, imgUrl2, printerWidth = 384) => {
  return new Promise((resolve, reject) => {
    const img1 = new Image();
    const img2 = new Image();

    let loadedCount = 0;
    const onImageLoad = () => {
      loadedCount++;
      if (loadedCount === 2) {
        const canvas = document.createElement("canvas");
        canvas.width = printerWidth;
        const targetWidthPerImg = printerWidth / 2;
        const h1 = (targetWidthPerImg / img1.width) * img1.height;
        const h2 = (targetWidthPerImg / img2.width) * img2.height;
        const y = (canvas.height - img2.height) / 2;
        canvas.height = Math.max(h1, h2);
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img1, 0, 0, targetWidthPerImg, h1);
        ctx.drawImage(
          img2,
          targetWidthPerImg,
          -y,
          targetWidthPerImg,
          canvas.height,
        );
        resolve(canvas.toDataURL("image/png"));
      }
    };
    img1.onload = onImageLoad;
    img2.onload = onImageLoad;
    img1.onerror = reject;
    img2.onerror = reject;
    img1.src = imgUrl1;
    img2.src = imgUrl2;
  });
};

async function print(orden, registro, empleado, cocina) {
  const imglogo = URL.createObjectURL(
    await resizeImage(
      registro.imgticket ? registro.imgticket : registro.img,
      80,
      80,
    ),
  );
  const imglogor = URL.createObjectURL(
    await resizeImage(
      "/static/media/logonaranja.47703c147962eb0583b9.png",
      180,
      180,
    ),
  );
  // const combinedBase64 = await mergeImagesForPrinter(imglogo, imglogor, 360);
  const combinedBase64 = await mergeImagesForPrinter(imglogo, imglogor, 320);
  const encoder = (text) => new TextEncoder().encode(text.replace("ñ", "n"));
  //importantisimo
  // width 32 para la impresora de 58mm
  // width 48 para la impresora de 80mm
  let width = 32;
  if (tipoposd === "80") {
    width = 48;
  }
  const receipt = await render(
    <Printer type="epson" width={width} encoder={encoder}>
      {orden.fecha ? (
        <>
          {!cocina && (
            <>
              <Imag
                src={combinedBase64}
                align="center"
                transforms={[transforms.floydSteinberg]}
              />
              <Text bold={true} size={{ width: 2, height: 2 }} align="center">
                {registro.nameticket}
              </Text>
              <Text align="center">Razon social:</Text>
              <Text align="center">
                {registro.razon_socialticket ? registro.razon_social : ""}
              </Text>
              <Text align="center">
                {registro.calleticket
                  ? registro.calleticket +
                    " #" +
                    registro.numdomticket +
                    " Col." +
                    registro.coloniaticket +
                    " C.P. " +
                    registro.codigopticket
                  : ""}
              </Text>
              <Text align="center">
                {registro.municipioticket
                  ? registro.municipioticket +
                    ", " +
                    registro.estadoticket +
                    " " +
                    registro.paisticket
                  : ""}
              </Text>
              <Text align="center">
                {registro.sucursalticket
                  ? "Sucursal:" + registro.sucursalticket
                  : ""}
              </Text>
              <Text align="center">
                {registro.rfcticket ? "RFC:" + registro.rfcticket : ""}
              </Text>
              <Text align="center">
                {registro.phoneticket
                  ? "Telefono: " + registro.phoneticket
                  : ""}
              </Text>
              <Br />
            </>
          )}
          {width < 48 ? (
            <>
              <Text align="left">Folio: {orden.folio}</Text>
              <Text align="left">
                Fecha y hora:{" "}
                {orden.fecha.seconds
                  ? new Date(orden.fecha.seconds * 1000).toLocaleDateString() +
                    " " +
                    new Date(orden.fecha.seconds * 1000).toLocaleTimeString()
                  : orden.fecha.toLocaleDateString() +
                    " " +
                    orden.fecha.toLocaleTimeString()}
              </Text>
            </>
          ) : (
            <Row
              left={<Text align="left">Folio: {orden.folio}</Text>}
              right={
                <Text align="left">
                  Fecha y hora:{" "}
                  {orden.fecha.seconds
                    ? new Date(
                        orden.fecha.seconds * 1000,
                      ).toLocaleDateString() +
                      " " +
                      new Date(orden.fecha.seconds * 1000).toLocaleTimeString()
                    : orden.fecha.toLocaleDateString() +
                      " " +
                      orden.fecha.toLocaleTimeString()}
                </Text>
              }
            />
          )}
          {orden.table ? <Text align="left">Mesa: {orden.table}</Text> : ""}
          <Text align="left">Cliente: {orden.user_name}</Text>
          <Text align="left">Atendido por: {empleado}</Text>
          <Br />
          {!cocina ? (
            <Row left={"Producto(precio):cantidad"} right={"Total"} />
          ) : (
            <Row left={"Producto"} right={"Cantidad"} />
          )}

          <Br />
          {orden.detalle.map((item, index) => (
            <>
              {!cocina ? (
                <Row
                  left={
                    item.name +
                    "(" +
                    "$" +
                    parseFloat(item.costo).toFixed(2) +
                    "):" +
                    item.cantidad
                  }
                  right={<Text>${parseFloat(item.total).toFixed(2)} </Text>}
                />
              ) : (
                <Row
                  left={<Text>{item.name}</Text>}
                  right={<Text>{item.cantidad}</Text>}
                />
              )}

              {item.ingredientes &&
              Object.keys(item.ingredientes).length > 0 ? (
                <Text>-Ingredientes</Text>
              ) : (
                ""
              )}
              {item.ingredientes ? (
                Object.keys(item.ingredientes).map((obj, i) => {
                  return (
                    <Text>
                      --{item.ingredientes[obj].name}
                      {": " + item.ingredientes[obj].cantidad}
                    </Text>
                  );
                })
              ) : (
                <></>
              )}
              {item.anadidos && Object.keys(item.anadidos).length > 0 ? (
                <Text>-Añadidos</Text>
              ) : (
                ""
              )}
              {item.anadidos ? (
                Object.keys(item.anadidos).map((obj, i) => {
                  return (
                    <Text>
                      --{item.anadidos[obj].name}(
                      {!cocina &&
                      parseFloat(
                        item.anadidos[obj].precio * item.anadidos[obj].cantidad,
                      ) > 0
                        ? "+$" +
                          (
                            item.anadidos[obj].precio *
                            item.anadidos[obj].cantidad
                          ).toFixed(2)
                        : parseFloat(item.anadidos[obj].costo) > 0
                          ? "$" +
                            (
                              parseFloat(item.anadidos[obj].costo) *
                              item.anadidos[obj].cantidad
                            ).toFixed(2)
                          : "Gratis"}
                      {cocina && item.anadidos[obj].cantidad})
                    </Text>
                  );
                })
              ) : (
                <></>
              )}
            </>
          ))}
          {!cocina && (
            <>
              <Line />
              <Text align="right">
                Subtotal: ${(orden.total / (1 + orden.iva / 100)).toFixed(2)}
              </Text>
              <Text align="right">
                IVA ({orden.iva}%): ${orden.cobroiva.toFixed(2)}
              </Text>
              <Text align="right">IEPS: $0.00</Text>
              <Text align="right">Total: ${orden.total.toFixed(2)}</Text>
              <Text align="right">
                {window.convertir.NumerosALetras(orden.total.toFixed(2))}
              </Text>
              {width < 40 && <Br />}
              {/* <Text align="left">Total: ${orden.total.toFixed(2)}</Text> */}
              <Text align="left">Puntos utilizados: {orden.puntosusados}</Text>
              <Line />
              <Text align="left">
                Nuevo total: $
                {(
                  orden.total -
                  orden.puntosusados *
                    (orden.equivalenciapuntos
                      ? parseFloat(orden.equivalenciapuntos)
                      : 0)
                ).toFixed(2)}
              </Text>
              <Text align="left">
                Pago: ${parseFloat(orden.cobro).toFixed(2)}
              </Text>
              <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>
                Cambio: $
                {orden.cambio < 0
                  ? (-parseFloat(orden.cambio)).toFixed(2)
                  : parseFloat(orden.cambio).toFixed(2)}
              </Text>
              <Text align="left">Metodo de pago: {orden.tipo_pago}</Text>
              <Text align="left">Pago en una sola exhibicion.</Text>
              {registro.Tpuntos ? (
                <Text align="left">
                  Puntos generados: {orden.puntosgenerados}
                </Text>
              ) : (
                <></>
              )}
              <Br />
              <Text align="center">FACTURACION</Text>
              <Text align="center">
                Estimado cliente si usted desea facturar su compra puede hacerlo
                mediante el siguiente codigo QR, ahi podra realizar la factura
                por su consumo.
              </Text>
              <QRCode
                align="center"
                cellSize={8}
                content={"https://quickchart.io/qr?text=QRT-" + orden.id}
              />
              <Text align="center">Codigo de su orden :</Text>
              <Text align="center">{" " + orden.id}</Text>
              <Text align="center">¡Gracias por su compra!</Text>
              <Text align="center">
                Queremos su opinion, califica nuestro servicio por medio del QR.
              </Text>
            </>
          )}
        </>
      ) : (
        <></>
      )}
      <Cut lineFeeds={4} />
      <Cashdraw pin="5pin" />
    </Printer>,
  );
  return receipt;
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function normalizeHex(value) {
  if (value == null) {
    return null;
  }
  let stringValue = String(value).trim().toLowerCase();
  if (stringValue.startsWith("0x")) {
    stringValue = stringValue.substring(2);
  }
  return stringValue;
}

function parsePrinterString(value) {
  if (!value) {
    throw new Error("No se especifico una impresora.");
  }
  const stringValue = String(value).trim();
  const parts = stringValue.split(":");
  const type = parts[0].toUpperCase();
  if (type === "USB") {
    if (!parts[1] || !parts[2]) {
      throw new Error(
        "Formato USB invalido. Use USB:VENDORID:PRODUCTID[:SERIAL]",
      );
    }
    return {
      type: "USB",
      vendorId: parseInt(normalizeHex(parts[1]), 16),
      productId: parseInt(normalizeHex(parts[2]), 16),
      serialNumber: parts[3] || null,
      id: stringValue,
    };
  }
  if (type === "COM" || type === "SERIAL") {
    return {
      type: "COM",
      vendorId: parts[1] ? Number(parts[1]) : null,
      productId: parts[2] ? Number(parts[2]) : null,
      portName: parts[3] || null,
      baudRate: parts[4] ? Number(parts[4]) : PRINTER_CONFIG.serialBaudRate,
      id: stringValue,
    };
  }
  if (type === "BT" || type === "BLUETOOTH") {
    return {
      type: "Bluetooth",
      deviceId: parts.slice(1).join(":"),
      name: parts.slice(1).join(":"),
      id: stringValue,
    };
  }
  throw new Error(`Tipo de impresora no soportado: ${type}`);
}
function savePrinterCookies() {
  Cookies.set("endpoints", endpoints || "");
  Cookies.set("tipoimp", tipoimp || "");
  Cookies.set("tipoposd", tipoposd || "");
  if (printerState.usbVendorId != null) {
    Cookies.set("usbVendorId", String(printerState.usbVendorId));
  }
  if (printerState.usbProductId != null) {
    Cookies.set("usbProductId", String(printerState.usbProductId));
  }
  if (printerState.usbSerialNumber) {
    Cookies.set("usbSerialNumber", printerState.usbSerialNumber);
  }
  if (printerState.serialVendorId != null) {
    Cookies.set("serialVendorId", String(printerState.serialVendorId));
  }
  if (printerState.serialProductId != null) {
    Cookies.set("serialProductId", String(printerState.serialProductId));
  }
  if (printerState.bluetoothDeviceId) {
    Cookies.set("bluetoothDeviceId", printerState.bluetoothDeviceId);
  }
  if (printerState.bluetoothDeviceName) {
    Cookies.set("bluetoothDeviceName", printerState.bluetoothDeviceName);
  }
  if (printerState.selectedPrinterId) {
    Cookies.set("selectedPrinterId", printerState.selectedPrinterId);
  }
}

function createUSBPrinterId(deviceUSB) {
  if (!deviceUSB) {
    return null;
  }
  const vendor = Number(deviceUSB.vendorId).toString(16).padStart(4, "0");
  const product = Number(deviceUSB.productId).toString(16).padStart(4, "0");
  if (deviceUSB.serialNumber) {
    return `USB:${vendor}:${product}:${deviceUSB.serialNumber}`;
  }
  return `USB:${vendor}:${product}`;
}

function createSerialPrinterId(port) {
  if (!port) {
    return null;
  }
  const info = port.getInfo ? port.getInfo() : {};
  const vendor = info.usbVendorId != null ? info.usbVendorId : "unknown";
  const product = info.usbProductId != null ? info.usbProductId : "unknown";
  return `COM:${vendor}:${product}`;
}

function createBluetoothPrinterId(bluetoothDevice) {
  if (!bluetoothDevice) {
    return null;
  }
  return `BT:${bluetoothDevice.id}`;
}

async function setupUSB(usbDevice) {
  if (!usbDevice) {
    throw new Error("No se proporciono un dispositivo USB.");
  }
  if (!usbDevice.opened) {
    await usbDevice.open();
  }
  if (!usbDevice.configuration) {
    await usbDevice.selectConfiguration(1);
  }
  let interfaceNumber = PRINTER_CONFIG.usbInterface;
  let outEndpoint = null;
  for (const usbInterface of usbDevice.configuration.interfaces) {
    for (const alternate of usbInterface.alternates) {
      for (const endpoint of alternate.endpoints) {
        if (endpoint.direction === "out" && endpoint.type === "bulk") {
          interfaceNumber = usbInterface.interfaceNumber;
          outEndpoint = endpoint.endpointNumber;
          break;
        }
      }
      if (outEndpoint !== null) {
        break;
      }
    }
    if (outEndpoint !== null) {
      break;
    }
  }
  if (outEndpoint === null) {
    throw new Error("No se encontro un endpoint USB de salida OUT/BULK.");
  }
  try {
    await usbDevice.claimInterface(interfaceNumber);
  } catch (error) {
    console.warn("No fue posible reclamar nuevamente la interfaz USB:", error);
  }
  endpoints = outEndpoint;
  return {
    device: usbDevice,
    interfaceNumber,
    endpointNumber: outEndpoint,
  };
}

async function findAuthorizedUSBDevice(config = null) {
  if (!navigator.usb || !navigator.usb.getDevices) {
    throw new Error("WebUSB no esta disponible.");
  }
  const devices = await navigator.usb.getDevices();
  if (!devices.length) {
    return null;
  }
  if (config) {
    const found = devices.find((usbDevice) => {
      if (usbDevice.vendorId !== config.vendorId) {
        return false;
      }
      if (usbDevice.productId !== config.productId) {
        return false;
      }
      if (config.serialNumber) {
        return (usbDevice.serialNumber || null) === config.serialNumber;
      }
      return true;
    });
    if (found) {
      return found;
    }
  }
  if (printerState.usbVendorId != null && printerState.usbProductId != null) {
    const savedDevice = devices.find((usbDevice) => {
      if (usbDevice.vendorId !== printerState.usbVendorId) {
        return false;
      }
      if (usbDevice.productId !== printerState.usbProductId) {
        return false;
      }
      if (printerState.usbSerialNumber) {
        return (
          (usbDevice.serialNumber || null) === printerState.usbSerialNumber
        );
      }
      return true;
    });
    if (savedDevice) {
      return savedDevice;
    }
  }
  return devices[0];
}

async function requestUSBPrinter() {
  if (!navigator.usb || !navigator.usb.requestDevice) {
    throw new Error("WebUSB no esta disponible en este navegador.");
  }
  const usbDevice = await navigator.usb.requestDevice({
    filters: [],
  });
  return usbDevice;
}

async function connectUSBPrinter(configOrDevice) {
  printerState.manualRelease = false;
  let config = null;
  let usbDevice = null;
  if (configOrDevice && typeof configOrDevice.open === "function") {
    usbDevice = configOrDevice;
  } else {
    config =
      typeof configOrDevice === "string"
        ? parsePrinterString(configOrDevice)
        : configOrDevice;
  }
  if (!usbDevice) {
    usbDevice = await findAuthorizedUSBDevice(config);
  }
  if (!usbDevice) {
    throw new Error(
      "No hay una impresora USB autorizada. Utilice requestUSBPrinter().",
    );
  }
  const setupResult = await setupUSB(usbDevice);
  printerState.usbDevice = usbDevice;
  printerState.connected = true;
  printerState.connecting = false;
  printerState.usbVendorId = usbDevice.vendorId;
  printerState.usbProductId = usbDevice.productId;
  printerState.usbSerialNumber = usbDevice.serialNumber || null;
  device = usbDevice;
  const printerId = createUSBPrinterId(usbDevice);
  printerState.printers[printerId] = {
    id: printerId,
    type: "USB",
    name:
      usbDevice.productName ||
      `USB ${usbDevice.vendorId}:${usbDevice.productId}`,
    device: usbDevice,
    endpointNumber: setupResult.endpointNumber,
    interfaceNumber: setupResult.interfaceNumber,
    connected: true,
  };
  savePrinterCookies();
  return printerState.printers[printerId];
}

async function printUSB(printer, data) {
  if (!printer) {
    throw new Error("No se proporciono impresora USB.");
  }
  const usbDevice = printer.device || printerState.usbDevice;
  if (!usbDevice) {
    throw new Error("La impresora USB no esta conectada.");
  }
  if (!usbDevice.opened) {
    await setupUSB(usbDevice);
  }
  const endpointNumber = printer.endpointNumber || endpoints;
  if (endpointNumber == null) {
    throw new Error("No existe endpoint USB.");
  }
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const CHUNK_SIZE = 4096;
  for (let offset = 0; offset < bytes.length; offset += CHUNK_SIZE) {
    const chunk = bytes.slice(offset, offset + CHUNK_SIZE);
    await usbDevice.transferOut(endpointNumber, chunk);
  }
  return true;
}

async function closeUSB(printer = null) {
  const usbDevice = printer?.device || printerState.usbDevice || device;
  if (!usbDevice) {
    return;
  }
  try {
    if (usbDevice.opened) {
      try {
        await usbDevice.releaseInterface(
          printer?.interfaceNumber ?? PRINTER_CONFIG.usbInterface,
        );
      } catch (error) {
        console.warn("No se pudo liberar interfaz USB:", error);
      }
      await usbDevice.close();
    }
  } catch (error) {
    console.warn("No se pudo cerrar USB:", error);
  }
  const printerId = createUSBPrinterId(usbDevice);
  if (printerState.printers[printerId]) {
    printerState.printers[printerId].connected = false;
  }
  if (printerState.usbDevice === usbDevice) {
    printerState.usbDevice = null;
  }
  if (device === usbDevice) {
    device = null;
  }
  printerState.connected = false;
}

async function getAuthorizedUSBPrinters() {
  if (!navigator.usb || !navigator.usb.getDevices) {
    return [];
  }
  const devices = await navigator.usb.getDevices();
  return devices.map((usbDevice) => {
    const id = createUSBPrinterId(usbDevice);
    return {
      id,
      type: "USB",
      name:
        usbDevice.productName ||
        `USB ${usbDevice.vendorId}:${usbDevice.productId}`,
      vendorId: usbDevice.vendorId,
      productId: usbDevice.productId,
      serialNumber: usbDevice.serialNumber || null,
      connected: usbDevice.opened,
      device: usbDevice,
    };
  });
}

async function findAuthorizedSerialPort(config = null) {
  if (!navigator.serial || !navigator.serial.getPorts) {
    throw new Error("Web Serial no esta disponible.");
  }
  const ports = await navigator.serial.getPorts();
  if (!ports.length) {
    return null;
  }
  if (config) {
    const found = ports.find((port) => {
      const info = port.getInfo ? port.getInfo() : {};
      if (config.vendorId != null && info.usbVendorId !== config.vendorId) {
        return false;
      }
      if (config.productId != null && info.usbProductId !== config.productId) {
        return false;
      }
      return true;
    });
    if (found) {
      return found;
    }
  }
  if (
    printerState.serialVendorId != null &&
    printerState.serialProductId != null
  ) {
    const savedPort = ports.find((port) => {
      const info = port.getInfo ? port.getInfo() : {};
      return (
        info.usbVendorId === printerState.serialVendorId &&
        info.usbProductId === printerState.serialProductId
      );
    });
    if (savedPort) {
      return savedPort;
    }
  }
  return ports[0];
}

async function requestSerialPrinter() {
  if (!navigator.serial || !navigator.serial.requestPort) {
    throw new Error("Web Serial no esta disponible.");
  }
  const port = await navigator.serial.requestPort();
  return port;
}

async function connectSerialPrinter(configOrPort) {
  printerState.manualRelease = false;
  let config = null;
  let port = null;
  if (configOrPort && typeof configOrPort.open === "function") {
    port = configOrPort;
  } else {
    config =
      typeof configOrPort === "string"
        ? parsePrinterString(configOrPort)
        : configOrPort;
  }
  if (!port) {
    port = await findAuthorizedSerialPort(config);
  }
  if (!port) {
    throw new Error(
      "No hay un puerto Serial autorizado. " +
        "Utilice requestSerialPrinter().",
    );
  }
  const baudRate = config?.baudRate || PRINTER_CONFIG.serialBaudRate;
  if (!port.readable && !port.writable) {
    await port.open({
      baudRate,
    });
  }
  const info = port.getInfo ? port.getInfo() : {};
  printerState.serialPort = port;
  printerState.serialVendorId = info.usbVendorId ?? null;
  printerState.serialProductId = info.usbProductId ?? null;
  printerState.connected = true;
  printerState.connecting = false;
  device = port;
  const printerId = createSerialPrinterId(port);
  printerState.printers[printerId] = {
    id: printerId,
    type: "COM",
    name:
      config?.portName ||
      `COM ${info.usbVendorId || ""}:${info.usbProductId || ""}`,
    port,
    baudRate,
    vendorId: info.usbVendorId ?? null,
    productId: info.usbProductId ?? null,
    connected: true,
  };
  savePrinterCookies();
  return printerState.printers[printerId];
}

async function printSerial(printer, data) {
  if (!printer) {
    throw new Error("No se proporciono impresora Serial.");
  }
  const port = printer.port || printerState.serialPort;
  if (!port) {
    throw new Error("El puerto Serial no esta conectado.");
  }
  if (!port.writable) {
    throw new Error("El puerto Serial no esta disponible para escritura.");
  }
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const writer = port.writable.getWriter();
  try {
    await writer.write(bytes);
  } finally {
    writer.releaseLock();
  }
  return true;
}

async function closeSerial(printer = null) {
  const port = printer?.port || printerState.serialPort || device;
  if (!port) {
    return;
  }
  try {
    if (port.readable || port.writable) {
      await port.close();
    }
  } catch (error) {
    console.warn("No se pudo cerrar Serial:", error);
  }
  const printerId = createSerialPrinterId(port);
  if (printerState.printers[printerId]) {
    printerState.printers[printerId].connected = false;
  }
  if (printerState.serialPort === port) {
    printerState.serialPort = null;
  }
  if (device === port) {
    device = null;
  }
  printerState.connected = false;
}

async function getAuthorizedSerialPrinters() {
  if (!navigator.serial || !navigator.serial.getPorts) {
    return [];
  }
  const ports = await navigator.serial.getPorts();
  return ports.map((port) => {
    const info = port.getInfo ? port.getInfo() : {};
    const id = createSerialPrinterId(port);
    return {
      id,
      type: "COM",
      name: `Serial ${info.usbVendorId || "?"}:${info.usbProductId || "?"}`,
      vendorId: info.usbVendorId ?? null,
      productId: info.usbProductId ?? null,
      connected: !!(port.readable || port.writable),
      port,
    };
  });
}

function configureBluetooth(options = {}) {
  if (options.serviceUUID) {
    printerState.bluetoothServiceUUID = options.serviceUUID;
    Cookies.set("bluetoothServiceUUID", options.serviceUUID);
  }
  if (options.characteristicUUID) {
    printerState.bluetoothCharacteristicUUID = options.characteristicUUID;
    Cookies.set("bluetoothCharacteristicUUID", options.characteristicUUID);
  }
  if (options.chunkSize) {
    PRINTER_CONFIG.bluetoothChunkSize = Number(options.chunkSize);
  }
  return {
    serviceUUID: printerState.bluetoothServiceUUID,
    characteristicUUID: printerState.bluetoothCharacteristicUUID,
    chunkSize: PRINTER_CONFIG.bluetoothChunkSize,
  };
}

async function getAuthorizedBluetoothPrinters() {
  if (!navigator.bluetooth || !navigator.bluetooth.getDevices) {
    return [];
  }
  const devices = await navigator.bluetooth.getDevices();
  return devices.map((bluetoothDevice) => {
    const id = createBluetoothPrinterId(bluetoothDevice);
    return {
      id,
      type: "Bluetooth",
      name: bluetoothDevice.name || "Bluetooth sin nombre",
      device: bluetoothDevice,
      connected: !!(bluetoothDevice.gatt && bluetoothDevice.gatt.connected),
    };
  });
}

async function requestBluetoothPrinter(options = {}) {
  if (!navigator.bluetooth || !navigator.bluetooth.requestDevice) {
    throw new Error("Web Bluetooth no esta disponible.");
  }
  const serviceUUID = options.serviceUUID || printerState.bluetoothServiceUUID;
  const filters = options.filters || [];
  const optionalServices = options.optionalServices || [serviceUUID];
  const requestOptions = {
    ...(filters.length ? { filters } : { acceptAllDevices: true }),
    optionalServices,
  };
  const bluetoothDevice =
    await navigator.bluetooth.requestDevice(requestOptions);
  return bluetoothDevice;
}

function getBluetoothCharacteristic() {
  return printerState.bluetoothCharacteristic;
}

async function connectBluetoothPrinter(configOrDevice) {
  printerState.manualRelease = false;
  let config = null;
  let bluetoothDevice = null;
  if (configOrDevice && configOrDevice.gatt) {
    bluetoothDevice = configOrDevice;
  } else {
    config =
      typeof configOrDevice === "string"
        ? parsePrinterString(configOrDevice)
        : configOrDevice;
  }
  if (!bluetoothDevice) {
    const devices = await getAuthorizedBluetoothPrinters();
    if (config?.deviceId) {
      const found = devices.find((item) => item.device.id === config.deviceId);
      if (found) {
        bluetoothDevice = found.device;
      }
    }
    if (!bluetoothDevice && printerState.bluetoothDeviceId) {
      const found = devices.find(
        (item) => item.device.id === printerState.bluetoothDeviceId,
      );
      if (found) {
        bluetoothDevice = found.device;
      }
    }
  }
  if (!bluetoothDevice) {
    bluetoothDevice = await requestBluetoothPrinter();
  }
  if (!bluetoothDevice) {
    throw new Error("No se selecciono dispositivo Bluetooth.");
  }
  if (!bluetoothDevice.gatt) {
    throw new Error("El dispositivo Bluetooth no soporta GATT.");
  }
  if (!bluetoothDevice.gatt.connected) {
    await bluetoothDevice.gatt.connect();
  }
  const service = await bluetoothDevice.gatt.getPrimaryService(
    printerState.bluetoothServiceUUID,
  );
  const characteristic = await service.getCharacteristic(
    printerState.bluetoothCharacteristicUUID,
  );
  printerState.bluetoothDevice = bluetoothDevice;
  printerState.bluetoothCharacteristic = characteristic;
  printerState.bluetoothDeviceId = bluetoothDevice.id;
  printerState.bluetoothDeviceName = bluetoothDevice.name || null;
  printerState.connected = true;
  printerState.connecting = false;
  device = bluetoothDevice;
  const printerId = createBluetoothPrinterId(bluetoothDevice);
  printerState.printers[printerId] = {
    id: printerId,
    type: "Bluetooth",
    name: bluetoothDevice.name || "Bluetooth",
    device: bluetoothDevice,
    characteristic,
    connected: true,
  };
  if (!bluetoothDevice.__printerDisconnectHandler) {
    const disconnectHandler = () => {
      console.warn("Bluetooth desconectado:", bluetoothDevice.name);
      printerState.connected = false;
      printerState.bluetoothCharacteristic = null;
      const id = createBluetoothPrinterId(bluetoothDevice);
      if (printerState.printers[id]) {
        printerState.printers[id].connected = false;
      }
    };
    bluetoothDevice.__printerDisconnectHandler = disconnectHandler;
    bluetoothDevice.addEventListener(
      "gattserverdisconnected",
      disconnectHandler,
    );
  }
  savePrinterCookies();
  return printerState.printers[printerId];
}

async function printBluetooth(printer, data) {
  const characteristic =
    printer?.characteristic || printerState.bluetoothCharacteristic;
  if (!characteristic) {
    throw new Error("La characteristic Bluetooth no esta conectada.");
  }
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const chunkSize = PRINTER_CONFIG.bluetoothChunkSize;
  const writeMethod = characteristic.writeValueWithoutResponse
    ? "writeValueWithoutResponse"
    : "writeValue";
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    const chunk = bytes.slice(offset, offset + chunkSize);
    if (typeof characteristic[writeMethod] !== "function") {
      throw new Error("La characteristic Bluetooth no permite escritura.");
    }
    await characteristic[writeMethod](chunk);
  }
  return true;
}

async function closeBluetooth(printer = null) {
  const bluetoothDevice = printer?.device || printerState.bluetoothDevice;
  if (!bluetoothDevice) {
    return;
  }
  const id = createBluetoothPrinterId(bluetoothDevice);
  if (bluetoothDevice.__printerDisconnectHandler) {
    try {
      bluetoothDevice.removeEventListener(
        "gattserverdisconnected",
        bluetoothDevice.__printerDisconnectHandler,
      );
    } catch (error) {
      console.warn("No se pudo retirar listener Bluetooth:", error);
    }
    delete bluetoothDevice.__printerDisconnectHandler;
  }
  try {
    if (bluetoothDevice.gatt && bluetoothDevice.gatt.connected) {
      bluetoothDevice.gatt.disconnect();
    }
  } catch (error) {
    console.warn("No se pudo desconectar Bluetooth:", error);
  }
  if (printerState.printers[id]) {
    printerState.printers[id].connected = false;
  }
  if (printerState.bluetoothDevice === bluetoothDevice) {
    printerState.bluetoothDevice = null;
  }
  printerState.bluetoothCharacteristic = null;
  if (device === bluetoothDevice) {
    device = null;
  }
  printerState.connected = false;
}

async function getAvailablePrinters() {
  const printers = [];
  try {
    const usbPrinters = await getAuthorizedUSBPrinters();
    printers.push(...usbPrinters);
  } catch (error) {
    console.warn("Error obteniendo USB:", error);
  }
  try {
    const serialPrinters = await getAuthorizedSerialPrinters();
    printers.push(...serialPrinters);
  } catch (error) {
    console.warn("Error obteniendo Serial:", error);
  }
  try {
    const bluetoothPrinters = await getAuthorizedBluetoothPrinters();
    printers.push(...bluetoothPrinters);
  } catch (error) {
    console.warn("Error obteniendo Bluetooth:", error);
  }
  return printers;
}

async function requestPrinter(type) {
  const normalizedType = String(type).toUpperCase();
  let printer = null;
  if (normalizedType === "USB") {
    const usbDevice = await requestUSBPrinter();
    printer = await connectUSBPrinter(usbDevice);
  } else if (normalizedType === "COM" || normalizedType === "SERIAL") {
    const port = await requestSerialPrinter();
    printer = await connectSerialPrinter(port);
  } else if (normalizedType === "BLUETOOTH" || normalizedType === "BT") {
    const bluetoothDevice = await requestBluetoothPrinter();
    printer = await connectBluetoothPrinter(bluetoothDevice);
  } else {
    throw new Error(`Tipo de impresora no soportado: ${type}`);
  }
  if (printer) {
    printerState.selectedPrinterId = printer.id;
    Cookies.set("selectedPrinterId", printer.id);
  }
  return printer;
}

function getPrinter(printerId) {
  if (!printerId) {
    return null;
  }
  return printerState.printers[printerId] || null;
}

async function selectPrinter(printerOrString) {
  let config = null;
  if (typeof printerOrString === "string") {
    config = parsePrinterString(printerOrString);
  } else {
    config = printerOrString;
  }
  if (!config) {
    throw new Error("No se proporciono impresora.");
  }
  if (config.id && printerState.printers[config.id]) {
    const printer = printerState.printers[config.id];
    printerState.selectedPrinterId = printer.id;
    Cookies.set("selectedPrinterId", printer.id);
    return printer;
  }
  let printer;
  switch (String(config.type).toUpperCase()) {
    case "USB":
      printer = await connectUSBPrinter(config);
      break;
    case "COM":
      printer = await connectSerialPrinter(config);
      break;
    case "SERIAL":
      printer = await connectSerialPrinter(config);
      break;
    case "BT":
      printer = await connectBluetoothPrinter(config);
      break;
    case "BLUETOOTH":
      printer = await connectBluetoothPrinter(config);
      break;
    default:
      throw new Error(`Tipo no soportado: ${config.type}`);
  }
  if (printer) {
    printerState.selectedPrinterId = printer.id;
    Cookies.set("selectedPrinterId", printer.id);
  }
  return printer;
}

async function selectAvailablePrinter(printerId) {
  const printers = await getAvailablePrinters();
  const found = printers.find((printer) => printer.id === printerId);
  if (!found) {
    throw new Error(
      "La impresora seleccionada no esta disponible o no ha sido autorizada.",
    );
  }
  return selectPrinter(found);
}

async function restoreSelectedPrinter() {
  const printerId = printerState.selectedPrinterId;
  if (!printerId) {
    return null;
  }
  try {
    return await selectPrinter(printerId);
  } catch (error) {
    console.warn("No fue posible restaurar la impresora seleccionada:", error);
    return null;
  }
}

async function connectPrinter(printerString) {
  const config =
    typeof printerString === "string"
      ? parsePrinterString(printerString)
      : printerString;

  if (!config) {
    throw new Error("No se proporcionó configuración de impresora.");
  }

  let printer;

  try {
    switch (String(config.type).toUpperCase()) {
      case "USB":
        printer = await connectUSBPrinter(config);

        break;

      case "COM":
      case "SERIAL":
        printer = await connectSerialPrinter(config);

        break;

      case "BT":
      case "BLUETOOTH":
        printer = await connectBluetoothPrinter(config);

        break;

      default:
        throw new Error(`Tipo de impresora no soportado: ${config.type}`);
    }

    // --------------------------------------------
    // ACTUALIZAR ESTADO GENERAL
    // --------------------------------------------

    actualizarEstadoImpresora(true, printer);

    return printer;
  } catch (error) {
    actualizarEstadoImpresora(false, config);

    throw error;
  }
}

async function ensurePrinterConnected(printerOrId) {
  let printer =
    typeof printerOrId === "string" ? getPrinter(printerOrId) : printerOrId;
  if (!printer) {
    throw new Error("No se encontro la impresora.");
  }
  if (printer.type === "USB") {
    if (printer.device && printer.device.opened) {
      printer.connected = true;
      return printer;
    }
    return await connectUSBPrinter(printer);
  }
  if (printer.type === "COM") {
    if (printer.port && printer.port.writable) {
      printer.connected = true;
      return printer;
    }
    return await connectSerialPrinter(printer);
  }
  if (printer.type === "Bluetooth") {
    if (
      printer.device &&
      printer.device.gatt &&
      printer.device.gatt.connected &&
      printer.characteristic
    ) {
      printer.connected = true;
      return printer;
    }
    return await connectBluetoothPrinter(printer);
  }
  throw new Error("Tipo de impresora desconocido.");
}

async function disconnectPrinter(printerOrId = null) {
  let printer = null;

  if (!printerOrId) {
    printer = impresoraActual;
  } else if (typeof printerOrId === "string") {
    printer = getPrinter(printerOrId);
  } else {
    printer = printerOrId;
  }

  if (!printer) {
    return;
  }

  try {
    switch (String(printer.type).toUpperCase()) {
      case "USB":
        await closeUSB(printer);
        break;
      case "COM":
      case "SERIAL":
        await closeSerial(printer);
        break;
      case "BT":
      case "BLUETOOTH":
        await closeBluetooth(printer);
        break;
      default:
        break;
    }
  } finally {
    actualizarEstadoImpresora(false, printer);

    impresoraActual = null;

    impresoraActualId = null;

    tipoImpresoraActual = null;
  }
}

function receiptToUint8Array(receipt) {
  if (!receipt) {
    throw new Error("El recibo esta vacio.");
  }
  if (receipt instanceof Uint8Array) {
    return receipt;
  }
  if (receipt instanceof ArrayBuffer) {
    return new Uint8Array(receipt);
  }
  if (ArrayBuffer.isView(receipt)) {
    return new Uint8Array(
      receipt.buffer,
      receipt.byteOffset,
      receipt.byteLength,
    );
  }
  if (Array.isArray(receipt)) {
    return new Uint8Array(receipt);
  }
  if (typeof Blob !== "undefined" && receipt instanceof Blob) {
    return receipt.arrayBuffer().then((buffer) => new Uint8Array(buffer));
  }
  throw new Error("Formato de receipt no soportado.");
}

async function executePrint(printer, receipt) {
  const connectedPrinter = await ensurePrinterConnected(printer);
  const data = await receiptToUint8Array(receipt);
  switch (String(connectedPrinter.type).toUpperCase()) {
    case "USB":
      return await printUSB(connectedPrinter, data);
    case "COM":
      return await printSerial(connectedPrinter, data);
    case "SERIAL":
      return await printSerial(connectedPrinter, data);
    case "BLUETOOTH":
      return await printBluetooth(connectedPrinter, data);
    case "BT":
      return await printBluetooth(connectedPrinter, data);
    default:
      throw new Error(
        `No existe metodo de impresion para ${connectedPrinter.type}`,
      );
  }
}

function queuePrint(printerOrId, receipt) {
  const job = printerState.printQueue
    .catch(() => {})
    .then(async () => {
      return await executePrint(printerOrId, receipt);
    });
  printerState.printQueue = job.catch((error) => {
    console.error("Error en cola de impresion:", error);
    throw error;
  });
  return job;
}

async function printToPrinter(printerId, receipt) {
  return queuePrint(printerId, receipt);
}

function actualizarEstadoImpresora(conectada, printer = null) {
  impresoraConectada = Boolean(conectada);

  if (printer) {
    impresoraActual = printer;
    impresoraActualId = printer.id;
    tipoImpresoraActual = printer.type;
  }

  if (!conectada && printer) {
    printer.connected = false;
  }

  console.log("Estado impresora:", {
    conectada: impresoraConectada,
    id: impresoraActualId,
    tipo: tipoImpresoraActual,
  });
}

async function ImpUSB(printerOrString = null, receipt = null) {
  let printer;

  if (printerOrString) {
    printer = await connectPrinter(printerOrString);
  } else {
    printer = await connectUSBPrinter();
  }

  if (receipt != null) {
    return queuePrint(printer, receipt);
  }

  return printer;
}

async function ImpCOM(printerOrString = null, receipt = null) {
  let printer;

  if (printerOrString) {
    printer = await connectPrinter(printerOrString);
  } else {
    printer = await connectSerialPrinter();
  }

  if (receipt != null) {
    return queuePrint(printer, receipt);
  }
  return printer;
}

async function ImpBluetooth(printerOrString = null, receipt = null) {
  let printer;
  if (printerOrString) {
    printer = await connectPrinter(printerOrString);
  } else {
    printer = await connectBluetoothPrinter();
  }
  if (receipt != null) {
    return queuePrint(printer, receipt);
  }
  return printer;
}

async function connectAndPrint(
  printerString,
  orden,
  registro,
  empleado,
  cocina,
) {
  const printer = await connectPrinter(printerString);
  const receipt = await print(orden, registro, empleado, cocina);
  return queuePrint(printer, receipt);
}

async function printReceipt(
  printerString,
  orden,
  registro,
  empleado,
  cocina = false,
) {
  const printer = await connectPrinter(printerString);
  const receipt = await print(orden, registro, empleado, cocina);
  return queuePrint(printer, receipt);
}

function getPrinterStatus(printerId = null) {
  const id = printerId || printerState.selectedPrinterId;
  if (!id) {
    return null;
  }
  const printer = getPrinter(id);
  if (!printer) {
    return null;
  }
  return {
    id: printer.id,
    type: printer.type,
    name: printer.name,
    connected: !!printer.connected,
  };
}

function getSelectedPrinter() {
  if (!printerState.selectedPrinterId) {
    return null;
  }
  return getPrinter(printerState.selectedPrinterId);
}

async function selectAvailablePrinterById(id) {
  const printers = await getAvailablePrinters();
  const printer = printers.find((item) => item.id === id);
  if (!printer) {
    throw new Error(`No se encontro la impresora ${id}`);
  }
  return selectPrinter(printer);
}

function resetConnectionReferences(type = null) {
  if (!type || type === "USB") {
    printerState.usbDevice = null;
  }
  if (!type || type === "COM" || type === "SERIAL") {
    printerState.serialPort = null;
  }
  if (!type || type === "Bluetooth" || type === "BLUETOOTH" || type === "BT") {
    printerState.bluetoothDevice = null;
    printerState.bluetoothCharacteristic = null;
  }
  printerState.connected = false;
}

async function reconnectPrinter(printerOrId) {
  let printer =
    typeof printerOrId === "string" ? getPrinter(printerOrId) : printerOrId;

  if (!printer) {
    throw new Error("No se encontro la impresora.");
  }
  let lastError = null;
  printerState.reconnecting = true;
  for (
    let attempt = 1;
    attempt <= PRINTER_CONFIG.reconnectAttempts;
    attempt++
  ) {
    try {
      console.log(
        `Reconexion ${attempt}/${
          PRINTER_CONFIG.reconnectAttempts
        } para ${printer.id}`,
      );
      let result;
      switch (String(printer.type).toUpperCase()) {
        case "USB":
          result = await connectUSBPrinter(printer);
          break;
        case "COM":
          result = await connectSerialPrinter(printer);
          break;
        case "SERIAL":
          result = await connectSerialPrinter(printer);
          break;
        case "BT":
          result = await connectBluetoothPrinter(printer);
          break;
        case "BLUETOOTH":
          result = await connectBluetoothPrinter(printer);
          break;
        default:
          throw new Error(`Tipo no soportado: ${printer.type}`);
      }
      printerState.reconnecting = false;
      return result;
    } catch (error) {
      lastError = error;
      console.warn(`Fallo de reconexion ${attempt}:`, error);
      if (attempt < PRINTER_CONFIG.reconnectAttempts) {
        await delay(PRINTER_CONFIG.reconnectDelay);
      }
    }
  }
  printerState.reconnecting = false;
  throw lastError || new Error("No fue posible reconectar la impresora.");
}

export {
  ImpUSB,
  ImpCOM,
  ImpBluetooth,
  connectAndPrint,
  connectPrinter,
  requestPrinter,
  getAvailablePrinters,
  selectPrinter,
  selectAvailablePrinter,
  selectAvailablePrinterById,
  restoreSelectedPrinter,
  getSelectedPrinter,
  getPrinterStatus,
  disconnectPrinter,
  reconnectPrinter,
  queuePrint,
  printToPrinter,
  printReceipt,
  configureBluetooth,
  impresoraConectada,
  impresoraActual,
  impresoraActualId,
  tipoImpresoraActual,
};
